module.exports = __webpack_public_path__ + "static/media/email_illustration_orange.f705f4f3.svg";